module.exports = __webpack_public_path__ + "static/media/Black Panther 1.ce67ab22.jpg";